import React from 'react';
import FSObjectIcon from './FSObjectIcon';
import {
  SearchInputFocusable,
  SearchInput,
  SearchResultDiv,
  SearchResultTextWrapper,
  SearchResultTitle,
  SearchResultDescription,
} from 'components/SearchInput';
import { TruncatedSearchResult } from 'components/TruncatedSearchResult';

export const ResultItem = ({ result, term, onClick }) => {
  return (
    <SearchResultDiv onClick={onClick.bind(null, result)}>
      <FSObjectIcon item={result} />
      <SearchResultTextWrapper>
        <SearchResultTitle>
          <TruncatedSearchResult result={result} term={term}/>
        </SearchResultTitle>
        <SearchResultDescription>
          in Dashboard
          {result.parentPath &&
            ` > ${result.parentPath.split(',').join(' > ')}`}
        </SearchResultDescription>
      </SearchResultTextWrapper>
    </SearchResultDiv>
  );
};

const FileSystemSearchInput = ({
  onChange,
  onResultClick,
  onCancel,
  value,
  results,
}) => {
  return (
    <SearchInput
      onChange={onChange}
      onResultClick={onResultClick}
      onCancel={onCancel}
      value={value}
      results={results}
      ResultItem={ResultItem}
    />
  );
};

export default FileSystemSearchInput;

export { SearchInputFocusable };
